"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTabs = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_bootstrap_1 = require("react-bootstrap");
var AcTabs_module_scss_1 = __importDefault(require("./AcTabs.module.scss"));
var AcTabs = function (props) {
    var id = props.id, defaultActiveKey = props.defaultActiveKey, tabs = props.tabs, children = props.children;
    var renderNavs = function () {
        return tabs.map(function (tab) {
            return (react_1.default.createElement(react_bootstrap_1.Nav.Item, { className: clsx_1.default(AcTabs_module_scss_1.default.tabNavItem, { 'border-primary': tab.active }) },
                react_1.default.createElement(react_bootstrap_1.Nav.Link, { className: clsx_1.default('fs-12 font-weight-bold', AcTabs_module_scss_1.default.tabNavLink), eventKey: tab.eventKey }, tab.title)));
        });
    };
    return (react_1.default.createElement(react_bootstrap_1.Tab.Container, { defaultActiveKey: defaultActiveKey, id: id },
        react_1.default.createElement(react_bootstrap_1.Nav, { className: AcTabs_module_scss_1.default.tabNav }, renderNavs()),
        react_1.default.createElement(react_bootstrap_1.Tab.Content, { className: "overflow-auto" }, children)));
};
exports.AcTabs = AcTabs;
exports.AcTabs.displayName = 'AcTabs';
//# sourceMappingURL=AcTabs.js.map